export default {
  // 重複調證確認對話框
  repeatConfirmTitle: "調證重複確認",
  addTotal: "本次共添加",
  addCount:
    "條調證數據，下列數據已加入過調證建議，請確認是否需要繼續加入調證？",

  // 表格列名
  addedBy: "添加人",
  addedTime: "添加時間",
  type: "類型",
  address: "地址",

  // 按鈕
  cancel: "取 消",
  confirm: "確 定",

  // 調證類型標題
  normalSurvey: "普通調證",
  keySurvey: "重點調證",

  // 調證分類
  exchangeSurvey: "交易所調證",
  exchangeSurveyDesc: "系統可自行匹配交易所調證數據",
  huobiSurvey: "火幣平台調證",
  huobiSurveyDesc: "需用戶確認",
  huobiTip:
    "由於火幣平台於2021年9月24日起停止大陸新用戶註冊，針對大陸用戶和海外用戶調證會涉及不同調證渠道，系統已根據當前調證數據特徵計算優先調證渠道，若該渠道無調證結果，用戶可手動切換其他渠道重新調證。",
  walletSurvey: "錢包調證",
  walletSurveyDesc: "用戶需自行選擇錢包平台",

  // 表單字段
  surveyPlatform: "調證平台",
  selectPlatform: "請選擇調證平台",
  selectOption: "請選擇",
  surveyReason: "調證原因",
  inputReason: "請輸入調證原因",

  // 提示消息
  selectSurveyData: "請選擇需要加入的調證",
  selectWalletPlatform: "請選擇錢包調證平台",
  inputReasonRequired: "請輸入調證原因",
  addSuccess: "已加入調證",
  successTitle: "成功",

  // 類型標籤
  hashType: "哈希",
};
